import { useEffect, useState } from "react";

/**
 * Returns true when window width is >= breakpoint (desktop-first).
 * @param {number} breakpoint - Min width in px for "above breakpoint" (e.g. 992).
 * @returns {boolean}
 */
export const useBreakpoint = (breakpoint) => {
  const [isAbove, setIsAbove] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth >= breakpoint : true
  );

  useEffect(() => {
    const handleResize = () => setIsAbove(window.innerWidth >= breakpoint);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [breakpoint]);

  return isAbove;
};
